<div class="razorpay-response">
  <div class="razorpay-response__container">
    <mat-card class="razorpay-response__card">
      <mat-card-header class="razorpay-response__header">
        <mat-card-title>
          <h4>Booking Status</h4>
        </mat-card-title>
        <button mat-icon-button (click)="close()" class="razorpay-response__close-btn">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-card-header>
      
      <mat-card-content class="razorpay-response__content">
        <div class="razorpay-response__status-container" 
             [ngClass]="status === 'success' ? 'razorpay-response__status--success' : 'razorpay-response__status--error'">
          <h2>Booking Status: {{ status | titlecase }}</h2>
        </div>
        
        <div class="razorpay-response__message-container">
          <b *ngIf="status === 'success'">
            <h3>Your booking is Confirmed with transaction Id= {{ bookingid }}</h3>
          </b>
          <b *ngIf="status !== 'success'">
            <h3>We are sorry, that your booking is not confirmed and booking Id= {{ bookingid }}</h3>
          </b>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>